import React from 'react';
import { ReactFlowProvider } from 'reactflow';
import 'reactflow/dist/style.css';
import { GraphProvider } from './GraphContext';
import GraphMapper from './GraphMapper'
import { useFrameDeferredResizeObserver } from './utils/frameDeferredResizeObserver'

const App = (props) => {
  return (
    <ReactFlowProvider>
      <GraphProvider workflow={props.workflow} selectedEntity={props.entity}>
        <GraphMapper workflow={props.workflow} toolbarSlot={props.toolbarSlot} canEdit={props.canEdit} />
      </GraphProvider>
    </ReactFlowProvider>
  );
};


const GraphMapperApp = ({selectedEntity, workflow, toolbarSlot, canEdit}) => {
    // Stops React Flow's "ResizeObserver loop" errors while the graph rebuilds (e.g. direction toggle)
    useFrameDeferredResizeObserver();

    return (
      <App workflow={workflow && workflow} entity={selectedEntity} toolbarSlot={toolbarSlot} canEdit={canEdit} />
    )
}

export default GraphMapperApp
